import React from 'react'
import ToolContainer from '../../components/Containers/ToolContainer'
import TemplateParser from './Tools/TemplateParser'
import DdParser from './Tools/DdParser'

import './MainPage.css'
import LegacyV2 from './Tools/LegacyV2'
import CsddGenerator from './Tools/CsddGenerator'

export default function MainPage(){
    // useEffect(()=>{
    //     toast.info('Always check for updates here⬇️', {
    //         autoClose: 3000,
    //         theme: 'colored',
    //         pauseOnHover: true,
    //     })
    // },[])

    return (
        <div className='x_body-container'>
            <ToolContainer title={'DD Report to DD Template'} toolName={'template-parser'} isDisabled={true}>
                <TemplateParser />
            </ToolContainer>
            <ToolContainer title={'CS DD to DD Report'} toolName={'dd-parser'} isDisabled={true}>
                <DdParser />
            </ToolContainer>
            <ToolContainer title={'Data Central Mini'} toolName={'legacy-v2'}>
                <LegacyV2 />
            </ToolContainer>
            <ToolContainer title={'CS DD Generator - under development'} toolName={'csdd-generator'} noConfig={true} isDisabled={true}>
                <CsddGenerator />
            </ToolContainer>
        </div>
    )
}